import { useEffect, useState } from 'react';

// Analogo a useIsScrollable de ole-web-application, pero para paginas de scroll
// normal de documento (sin layout flex interno): mide si el documento entero
// excede el alto del viewport en vez de un contenedor puntual.
export const usePageIsScrollable = (deps: unknown[] = []) => {
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const checkScrollable = () => setIsScrollable(document.documentElement.scrollHeight > window.innerHeight);
        checkScrollable();

        window.addEventListener('resize', checkScrollable);
        const resizeObserver = new ResizeObserver(checkScrollable);
        resizeObserver.observe(document.body);

        return () => {
            window.removeEventListener('resize', checkScrollable);
            resizeObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return isScrollable;
};
